var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"fill":"#FFB608","d":"M15 8A7 7 0 1 1 1 8 7 7 0 0 1 15 8"}}),_c('path',{attrs:{"fill":"#fff","d":"M7.394 9.207h1.212l.194-2.43V4H7.2v2.777zM7.2 12h1.6v-1.6H7.2z"}})])
}
var staticRenderFns = []

export default { render: render }